import axios from "@/utils/request";

// 活动列表
export function getActivityList(params) {
  return axios.get("/admin_api/v1/activity", { params });
}

// 添加活动
export function addActivity(data) {
  return axios.post(`/admin_api/v1/activity`, data);
}

// 编辑活动
export function editActivity(id, data) {
  return axios.put(`/admin_api/v1/activity/${id}`, data);
}

// 活动详情
export function getActivityDetail(id) {
  return axios.get(`/admin_api/v1/activity/${id}`);
}

// 活动上下架
export function activityDisplay(id, data) {
  return axios.put(`/admin_api/v1/activity/${id}/display`, data);
}
// 活动删除 /admin_api/v1/activity/{uuid}
export function activityDelete(id) {
  return axios.delete(`/admin_api/v1/activity/${id}`);
}

// 日志列表
export function getOperationLog(id) {
  return axios.get(`/admin_api/v1/activity/${id}/log`);
}

// 图片组件 AI 解读列表；componentId 可用于定向读取单个组件
export function getActivityAiText(id, params) {
  return axios.get(`/admin_api/v1/activity/${id}/ai_text`, { params });
}

// 保存图片组件人工解读
export function saveActivityAiText(id, data) {
  return axios.put(`/admin_api/v1/activity/${id}/ai_text`, data);
}

// 生成或重新生成图片组件 AI 解读
export function reinterpretActivityAiText(id, data) {
  return axios.post(`/admin_api/v1/activity/${id}/ai_text/reinterpret`, data);
}

// 汇总解读详情
export function getActivityAiMergedText(id) {
  return axios.get(`/admin_api/v1/activity/${id}/ai_merged_text`);
}

// 保存人工编辑的汇总解读
export function saveActivityAiMergedText(id, data) {
  return axios.put(`/admin_api/v1/activity/${id}/ai_merged_text`, data);
}
